import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { SettingsIndexRedirect } from '@apps/web/features/settings';

// Maps legacy `/settings?tab=…` deep links onto the dedicated per-section
// routes. The no-tab default is role-aware and resolved in the component below.
const TAB_TO_ROUTE = {
    user: '/settings/notifications',
    general: '/settings/team-members',
    recommendations: '/settings/recommendations',
    'shift-confirmations': '/settings/shift-confirmations',
    'data-sync': '/settings/data-sync',
    'tag-matching': '/settings/tag-matching',
} as const;

export const Route = createFileRoute('/_app/settings/')({
    validateSearch: z.object({
        tab: z
            .enum([
                'general',
                'recommendations',
                'shift-confirmations',
                'data-sync',
                'tag-matching',
                'user',
            ])
            .optional(),
        organizationId: z.string().optional(),
        source: z.enum(['activity']).optional(),
        unsubscribeEmailType: z.string().optional(),
    }),
    beforeLoad: ({ search }) => {
        // Tab deep links stay deterministic. The no-tab default is role-aware,
        // which needs the settings gates, so it is resolved in the component.
        if (!search.tab) {
            return;
        }
        const to = TAB_TO_ROUTE[search.tab];
        // Forward the deep-link params the notifications page validates so
        // email-unsubscribe and activity-return links keep working.
        if (to === '/settings/notifications') {
            throw redirect({
                to,
                search: {
                    organizationId: search.organizationId,
                    unsubscribeEmailType: search.unsubscribeEmailType,
                    source: search.source,
                },
            });
        }
        throw redirect({ to });
    },
    component: SettingsIndexRedirect,
});
